import { render } from "./BlockList.vue?vue&type=template&id=3cf8ec59&scoped=true"
import script from "./BlockList.vue?vue&type=script&lang=js"
export * from "./BlockList.vue?vue&type=script&lang=js"

import "./BlockList.vue?vue&type=style&index=0&id=3cf8ec59&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/xsurflog_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf8ec59"]])

export default __exports__